import React from "react";
import { Factory, Headset, ShieldCheck } from "lucide-react";
import { Reveal } from "../ui";

const PILLARS = [
  {
    icon: Factory,
    title: "Hardware + software, one team",
    desc: "We design the readers, write the firmware, and build the cloud and apps they talk to. No integration gaps.",
  },
  {
    icon: ShieldCheck,
    title: "Secure and reliable",
    desc: "Signed dynamic credentials, role-based control and offline validation keep every gate trustworthy.",
  },
  {
    icon: Headset,
    title: "Local, responsive support",
    desc: "Cairo-based engineers for rollout, training and SLA-backed maintenance across the region.",
  },
];

const About = () => (
  <section id="about" className="section">
    <div className="container grid gap-16 lg:grid-cols-12 lg:gap-12">
      <Reveal className="lg:col-span-5">
        <span className="eyebrow">
          <span className="h-1.5 w-1.5 rounded-full bg-brand-500" />
          About Fronix Studio
        </span>
        <h2 className="h-section mt-5">
          A decade of building the systems behind the gate.
        </h2>
      </Reveal>

      <Reveal delay={100} className="lg:col-span-7">
        <p className="text-lg leading-relaxed text-ink-300 sm:text-xl">
          Fronix Studio is a Cairo-based technology company specializing in access control. For more than{" "}
          <span className="font-semibold text-white">10 years</span> we have delivered identity and entry solutions,
          and today we build and operate{" "}
          <span className="font-semibold text-white">KNTO Pass</span>, a smart access and identity platform that
          combines cloud software, mobile applications, embedded systems and our own hardware into one ecosystem.
        </p>
        <p className="mt-6 text-lg leading-relaxed text-ink-400">
          We also partner with organizations that need something unique, engineering custom software on the same
          proven foundation.
        </p>
      </Reveal>
    </div>

    <div className="container mt-16 grid gap-4 md:grid-cols-3">
      {PILLARS.map(({ icon: Icon, title, desc }, i) => (
        <Reveal key={title} delay={i * 100} className="card card-hover p-8">
          <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-600/10 text-brand-500 ring-1 ring-inset ring-brand-600/20">
            <Icon className="h-6 w-6" />
          </span>
          <h3 className="mt-6 font-display text-xl font-semibold text-white">{title}</h3>
          <p className="mt-3 leading-relaxed text-ink-400">{desc}</p>
        </Reveal>
      ))}
    </div>
  </section>
);

export default About;
